import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { Group } from '../../../graphql/groups.datatypes';
import { gqlGroup } from '../getGroup.api';

interface DeleteGroupInput {
  id: number
}

interface DeleteGroupData {
  deleteGroup: Group
}

export const DELETE_GRUOP_MUTATION = gql`
    mutation deleteGroup($id: Int!) {
        deleteGroup(id: $id) {
            ${gqlGroup}
        }
    }
`;

export const deleteGroup = () => useMutation<DeleteGroupData, DeleteGroupInput>(
  DELETE_GRUOP_MUTATION,
  {
    update: updateCacheByType('Group'),
  }
);

export default deleteGroup;